import type { ParentComponent } from "solid-js";
import { A } from "@solidjs/router";
import { signOut } from "../lib/auth";

type ShellProps = {
  email: string;
  role: string | null;
};

const Shell: ParentComponent<ShellProps> = (props) => {
  return (
    <div class="app">
      <aside class="sidebar">
        <div class="brand">Ocean Admin</div>
        <nav>
          <A href="/" end class="nav-link" activeClass="active">
            Dashboard
          </A>
          <A href="/members" class="nav-link" activeClass="active">
            Members
          </A>
        </nav>
        <div class="sidebar-footer">
          <div class="user-email">{props.email}</div>
          <div class="muted small">
            role: {props.role ?? "—"}
          </div>
          <button class="link" onClick={() => signOut()}>
            Sign out
          </button>
        </div>
      </aside>
      <main class="content">{props.children}</main>
    </div>
  );
};

export default Shell;
